import { render, staticRenderFns } from "./advertise.vue?vue&type=template&id=4ce7caf4&scoped=true&"
import script from "./advertise.vue?vue&type=script&lang=js&"
export * from "./advertise.vue?vue&type=script&lang=js&"
import style0 from "./advertise.vue?vue&type=style&index=0&id=4ce7caf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7caf4",
  null
  
)

export default component.exports